module.exports = __webpack_public_path__ + "img/bg.d310b34c.png";